import React, {useEffect, useMemo, useState} from 'react';
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {ImageStamp, Table} from "../../../components";
import {adminToken} from "../../../helper";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

function ViewsTab({clickedCustomer}) {
    const id = clickedCustomer.id

    // Redux
    const dispatch = useDispatch();

    const {customers, userLikes, userRole} = useSelector(state => ({
        customers: state.customers?.users,
        userLikes: state.userLikes,
        userRole: state.userRole?.filter(role => role.module === "Users")
    }));

    // States
    const [tableRows, setTableRows] = useState();
    const [packageViews, setPackageViews] = useState();
    const [cPage, setCPage] = useState(1);

    // Fetch Package Add On
    // useEffect(() => {
    //     const {mobile, countrycode} =
    //     customers?.find(user => user?.userId == id) || {};

    //     dispatch(userLikesAction.get({countryCode: countrycode, mobile}));

    //     return () => dispatch(userLikesAction.reset());
    // }, [dispatch]);

    useEffect(() => {
        adminToken().then(token => axios
            .get(
                `${AWS_SERVER_APIS}/allpackageviewsdata?user_id=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            .then(res => {
               
                setPackageViews(res.data.data);
            })
        )
    }, [])


    useEffect(() => {
        let filtered = packageViews;
        if (!filtered?.length) return;

        // Map table rows
        const data = filtered?.map(obj => ({
            id: obj?.get_package_details?.id,
            packageName: obj?.get_package_details?.package_name,
            packageImage: <ImageStamp src={obj?.get_package_details.package_image}/>,
            shortDescription: obj?.get_package_details?.short_description,
            basePrice: obj?.get_package_details?.base_price,
            sellingPrice: obj?.get_package_details?.selling_price,
            viewOn: `${new Date(obj?.viewed_at).toLocaleString()}`
        }));
        setTableRows(data);
    }, [packageViews]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID"
            },
            {
                title: "Package Name",
                sortBy: "packageName"
            },
            {
                title: "Image"
            },
            {
                title: "Description"
            },
            {
                title: "Base Price"
            },
            {
                title: "Selling Price"
            },
            {
                title: "View On",
                sortBy: "viewOn"
            }
        ],
        [tableRows]
    );

    return <Table headers={tableHeaders} data={tableRows}/>;
}

export default ViewsTab;